import { render } from "./Principal-learningPath.vue?vue&type=template&id=527ead98&scoped=true"
import script from "./Principal-learningPath.vue?vue&type=script&lang=js"
export * from "./Principal-learningPath.vue?vue&type=script&lang=js"

import "./Principal-learningPath.vue?vue&type=style&index=0&id=527ead98&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527ead98"]])

export default __exports__